// extracted by mini-css-extract-plugin
export default {"body":"Map_body__zBxGi","body__main":"Map_body__main__EHyBL","dataMap__wrap":"Map_dataMap__wrap__nuMNQ","dataMap":"Map_dataMap__8Wr95","yandex":"Map_yandex__mjPuT"};